// extracted by mini-css-extract-plugin
export default {"title":"BackToLink__title___NkS5k"};